import React from "react";
import { ArrowRight } from "lucide-react";
import sectors from "../data/sectors";
import { sectorFlow } from "../data/content";

export default function Sectors() {
  return (
    <section className="section-py bg-lavender">
      <div className="container text-center">
        <h2 className="section-title">
          Every Each Business Sectors Connected Through SELECTEZI
        </h2>
        <p className="section-subtitle">
          SELECTEZI brings different sectors into one connected ecosystem
          Each sector can be both a resource provider and a resource seeker
        </p>

        <div className="sector-flow-bar mt-4">
          <div className="d-flex flex-wrap justify-content-center align-items-center gap-3">
            {sectorFlow.map((item, i) => {
              const Icon = item.icon;
              return (
                <React.Fragment key={item.label}>
                  <div className="sector-flow-item">
                    <div className="icon-wrap">
                      <Icon size={22} />
                    </div>
                    <span>{item.label}</span>
                  </div>
                  {i < sectorFlow.length - 1 && (
                    <ArrowRight className="sector-flow-arrow" size={18} />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        <div className="row g-4 mt-2 text-start sector-grid">
          {sectors.map((sector) => (
            <div className="col-md-6 col-lg-4" key={sector.id}>
              <div className="sector-card">
                <div className="sector-image-wrap">
                  <img src={sector.image} alt={sector.badge} />
                </div>
                <div className="sector-body">
                  <span
                    className="sector-label"
                    style={{ fontSize: "1rem", fontWeight: 700 }}
                  >
                    {sector.label}
                  </span>
                  <h3>{sector.title}</h3>
                  <p className="sector-subtitle">{sector.subtitle}</p>
                  <p className="sector-desc">{sector.description}</p>
                  <p className="connect-label">CONNECT WITH:</p>
                  <div className="connect-tags">
                    {sector.connectWith.map((tag) => (
                      <span className="connect-tag" key={tag}>
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
